import React from 'react';
import './StatsCard.css';

const StatsCard = ({ label, value, icon, color }) => {
  return (
    <div className={`stats-card ${color}`}>
      <div className="icon-wrapper">
        {icon}
      </div>
      <div className="stats-info">
        <h3>{value}</h3>
        <p>{label}</p>
      </div>
    </div>
  );
};

export default StatsCard;
